import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { ComponentsPage } from '@/areas/settings/bom-components/Settings/ComponentsPage/ComponentsPage';
import { canViewDesignSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/settings/_menu/organization/component-settings')({
    staticData: {
        access: { permissions: canViewDesignSettings },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <ComponentsPage />;
}
